export default __webpack_public_path__ + "static/media/stickerLock.45ba64ba.png";